export default [
  {
    component: () => import("pages/insights/OrganisationInsights.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Organisation Insights",
    },
    name: "organisation-insights",
    path: "/insights/:organisationId/:reportType?",
    props: (route) => ({
      view: route.query.view,
      ...route.params,
      ...route.query,
    }),
  },
  {
    component: () => import("pages/insights/GlobalGroupInsights.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Global Group Insights",
    },
    name: "global-group-insights",
    path: "/insights-global-group/:globalGroupId/:reportType?",
    props: (route) => ({
      view: route.query.view,
      ...route.params,
      ...route.query,
    }),
  },
  {
    component: () => import("pages/insights/EditInsightsGlobalGroup.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Global Group",
    },
    name: "insights-global-group-add",
    path: "/insights-global-group/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsGlobalGroup.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Global Group",
    },
    name: "insights-global-group-edit",
    path: "/insights-global-group/:globalGroupId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQuery.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Query",
    },
    name: "insights-query-add",
    path: "/insights/:organisationId/:reportType/insights-query/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQuery.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Query",
    },
    name: "insights-query-edit",
    path: "/insights/:organisationId/:reportType/insights-query/:queryId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQuery.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Topic",
    },
    name: "insights-topic-new",
    path: "/insights/:organisationId/:reportType/insights-topic/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQuery.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Topic",
    },
    name: "insights-topic-edit",
    path: "/insights/:organisationId/:reportType/insights-topic/:queryId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQuery.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Topic",
    },
    name: "insights-global-group-topic-new",
    path: "/insights-global-group/:globalGroupId/:reportType/insights-topic/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQuery.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Topic",
    },
    name: "insights-global-group-topic-edit",
    path: "/insights-global-group/:globalGroupId/:reportType/insights-topic/:queryId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsReport.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Insights Report",
    },
    name: "insights-report-add",
    path: "/insights/:organisationId/:reportType/insights-report/new",
    props: (route) => ({
      baseReportId: route.query.baseReportId,
      ...route.params,
      ...route.query,
    }),
  },
  {
    component: () => import("pages/insights/EditInsightsReport.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Insights Report",
    },
    name: "insights-report-edit",
    path: "/insights/:organisationId/:reportType/insights-report/:reportId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsEntity.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Insights Entity",
    },
    name: "insights-entity-add",
    path: "/insights/:organisationId/insights-entity/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsEntity.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Insights Entity",
    },
    name: "insights-entity-edit",
    path: "/insights/:organisationId/insights-entity/:entityId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsEntity.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Insights Entity",
    },
    name: "insights-global-group-entity-add",
    path: "/insights-global-group/:globalGroupId/insights-entity/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsEntity.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Insights Entity",
    },
    name: "insights-global-group-entity-edit",
    path: "/insights-global-group/:globalGroupId/insights-entity/:entityId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/InsightsReportPage.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "View Insights Qualitative Report",
    },
    name: "insights-report-qualitative",
    path: "/insights/:organisationId/insights-report/:reportId/queries",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsSentimentAnalysis.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Insights Qualitative analysis",
    },
    name: "insights-sentiment-analysis-edit",
    path: "/insights/:organisationId/insights-report/:reportId/sentiment-rating/:queryId",
    props: (route) => ({
      view: route.query.view,
      ...route.params,
      ...route.query,
    }),
  },
  {
    component: () => import("pages/insights/EditInsightsQualitativeTopic.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Qualitative Topic",
    },
    name: "insights-qualitative-topic-new",
    path: "/insights/:organisationId/insights-qualitative-topic/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQualitativeTopic.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Qualitative Topic",
    },
    name: "insights-qualitative-topic-edit",
    path: "/insights/:organisationId/insights-qualitative-topic/:topicId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQualitativeTopic.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Qualitative Topic",
    },
    name: "insights-global-group-qualitative-topic-new",
    path: "/insights-global-group/:globalGroupId/insights-qualitative-topic/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQualitativeTopic.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Qualitative Topic",
    },
    name: "insights-global-groupqualitative-topic-edit",
    path: "/insights-global-group/:globalGroupId/insights-qualitative-topic/:topicId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQualitativeTopic.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Key Message",
    },
    name: "insights-key-message-new",
    path: "/insights/:organisationId/insights-key-message/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQualitativeTopic.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Key Message",
    },
    name: "insights-key-message-edit",
    path: "/insights/:organisationId/insights-key-message/:topicId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQualitativeTopic.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Key Message",
    },
    name: "insights-global-group-key-message-new",
    path: "/insights-global-group/:globalGroupId/insights-key-message/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsQualitativeTopic.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Key Message",
    },
    name: "insights-global-group-key-message-edit",
    path: "/insights-global-group/:globalGroupId/insights-key-message/:topicId/edit",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsReportGroup.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Create Insights Report Group",
    },
    name: "insights-report-group-add",
    path: "/insights/:organisationId/:reportType/insights-report-group/new",
    props: true,
  },
  {
    component: () => import("pages/insights/EditInsightsReportGroup.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Edit Insights Report Group",
    },
    name: "insights-report-group-edit",
    path: "/insights/:organisationId/:reportType/insights-report-group/:groupId/edit",
    props: true,
  },
];
